module.exports = __webpack_public_path__ + "static/media/OATS_1x.22fa4256.png";